/** Вспомогательная модель со всеми полями  */
export default class HelpModel {
  /** Индекс */
  Id?: number = 0;
  /** Картина */
  Image?: string = "";
  /** Текст */
  Text?: string = "";
  /** Текст */
  Title?: string = "";
  /** Ссылка */
  Link?: string = "";
  /** Anchor */
  ScrollHash?: string = "";
  constructor(obj?: Partial<HelpModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
